// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"40d0c80d","453":"13e7e887","914":"47d661b3"}[chunkId] + ".chunk.js";
};